<mbs-modal [title]="'shared:computers.modals.agentUpdateRequiredCaption' | i18next">
  <ng-container modal-body>
    <mbs-alert
      [type]="alertType"
      [icon]="true"
      class="mb-0">
      <a
        class="cursor-pointer"
        (click)="openDownloadsSidepanel()">
        {{ 'shared:computers.modals.agentUpdateRequiredLinkText' | i18next }}
      </a>
      {{ 'shared:computers.modals.agentUpdateRequiredText' | i18next: { osName } }}
    </mbs-alert>
  </ng-container>
  <ng-container modalFooter>
    <mbs-button
      [type]="'secondary'"
      (click)="baseModal.close()">
      {{ 'shared:buttons.close' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
